import { Link } from 'react-router-dom';

import { completeName } from 'helpers/name';

const Following = ({ following: { user } }) => (
  <li>
    <Link
      to={Routes.user_path(user.id)}
      data-toggle="tooltip"
      title={completeName(user)}
    >
      <img alt={completeName(user)} className="big" src={user.photo_url} />
    </Link>
  </li>
);

export default Following;
